import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Instagram, Linkedin } from "lucide-react";

const LEGAL_LINKS = [
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/refund", label: "Refund Policy" },
  { to: "/contact", label: "Contact Us" },
];

export const Footer = () => {
  return (
    <footer
      className="relative border-t border-border py-12 md:py-16"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-8 items-start">
        <div className="md:col-span-4 space-y-4">
          <div className="flex items-center gap-2.5">
            <div className="h-11 w-11 rounded-xl bg-white dark:bg-white/95 grid place-items-center shadow-[0_8px_24px_rgba(255,122,0,0.25)] p-1">
              <img
                src="/digindia-logo.png"
                alt="DIGINDIA PAYTECH"
                className="h-full w-full object-contain"
              />
            </div>
            <div className="leading-none">
              <div className="font-heading font-extrabold tracking-tight text-base">
                DIGINDIA
              </div>
              <div className="text-[10px] tracking-[0.2em] text-muted-foreground font-medium">
                PAYTECH
              </div>
            </div>
          </div>
          <p className="text-sm text-muted-foreground max-w-sm leading-relaxed">
            We design and ship the digital identity of India&apos;s next
            million businesses — websites, apps and AI chat boards in 48
            hours.
          </p>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-border text-[11px] font-semibold tracking-wide">
            <span className="h-1.5 w-1.5 rounded-full bg-[#FF7A00]" />
            Built for Bharat 🇮🇳
          </div>
        </div>

        <div className="md:col-span-3 space-y-3">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-muted-foreground">
            Studio
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="/#services" className="hover:text-[#FF7A00] transition-colors" data-testid="footer-link-services">
                Services
              </a>
            </li>
            <li>
              <a href="/#transformation" className="hover:text-[#FF7A00] transition-colors" data-testid="footer-link-transformation">
                Transformation
              </a>
            </li>
            <li>
              <a href="/#chatbot" className="hover:text-[#FF7A00] transition-colors" data-testid="footer-link-chatbot">
                AI Chat Board
              </a>
            </li>
            <li>
              <a href="/#enquiry" className="hover:text-[#FF7A00] transition-colors" data-testid="footer-link-enquiry">
                Enquiry
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2 space-y-3">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-muted-foreground">
            Legal
          </div>
          <ul className="space-y-2 text-sm">
            {LEGAL_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="hover:text-[#00C853] transition-colors"
                  data-testid={`footer-legal-${l.to.replace("/", "")}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3 space-y-3">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-muted-foreground">
            Reach us
          </div>
          <div className="text-sm space-y-1">
            <div>care@digindiapaytech.com</div>
            <div>+91 9743032112</div>
            <div className="text-muted-foreground">Made with care in Bharat 🇮🇳</div>
          </div>
          <div className="flex items-center gap-2 pt-2">
            {[Twitter, Instagram, Linkedin].map((Ic, i) => (
              <a
                key={i}
                href="#"
                className="h-9 w-9 grid place-items-center rounded-full border border-border hover:bg-foreground/5 hover:scale-105 transition-all"
                aria-label="social"
                data-testid={`footer-social-${i}`}
              >
                <Ic className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-10 pt-6 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
        <div>© {new Date().getFullYear()} DIGINDIA PAYTECH. All rights reserved.</div>
        <div className="flex items-center gap-4">
          <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
          <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
          <Link to="/refund" className="hover:text-foreground transition-colors">Refund</Link>
          <Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
